import { render, staticRenderFns } from "./OtherLinkFooter.vue?vue&type=template&id=2fc98a43&scoped=true&"
import script from "./OtherLinkFooter.vue?vue&type=script&lang=js&"
export * from "./OtherLinkFooter.vue?vue&type=script&lang=js&"
import style0 from "./OtherLinkFooter.vue?vue&type=style&index=0&id=2fc98a43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc98a43",
  null
  
)

export default component.exports